import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "../Typography";
import TextField from "../TextField";
import Snackbar from "../Snackbar";
import Button from "../Button";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#D0C5E7",
    },
    secondary: {
      main: "#DBE2EF",
    },
    info: {
      main: "#112D4E",
    },
    success: {
      main: "#F9F7F7",
    },
  },
});

function EmailSection() {
  const [open, setOpen] = React.useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="section" sx={{ mt: 10, display: "flex" }}>
        <Grid container>
          <Grid item xs={12} md={6} sx={{ zIndex: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                bgcolor: "success.main",
                py: 8,
                px: 3,
              }}
            >
              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{ maxWidth: 400 }}
              >
                <Typography variant="h2" component="h2" gutterBottom>
                  Receive information
                </Typography>
                <Typography variant="h5">
                  Get information to the upcoming festivals.
                </Typography>
                <TextField
                  noBorder
                  placeholder="Your email"
                  variant="standard"
                  sx={{ width: "100%", mt: 3, mb: 2 }}
                />
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  sx={{ width: "100%" }}
                >
                  Keep me updated
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ display: { md: "block", xs: "none" }, position: "relative" }}
          >
            <Box
              sx={{
                position: "absolute",
                top: -67,
                left: -67,
                right: 0,
                bottom: 0,
                width: "100%",
                background:
                  "url(/static/themes/onepirate/productCTAImageDots.png)",
              }}
            />
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1505842465776-3b4953ca4f44?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
              alt="call to action"
              sx={{
                position: "absolute",
                top: -28,
                left: -28,
                right: 0,
                bottom: 0,
                width: "100%",
                maxWidth: 600,
              }}
            />
          </Grid>
        </Grid>
        <Snackbar
          open={open}
          closeFunc={handleClose}
          message="We will send you our best offers, once a week."
        />
      </Container>
    </ThemeProvider>
  );
}

export default EmailSection;
